import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppFloat = () => {
  const [isHovered, setIsHovered] = useState(false);
  const phoneNumber = '905414220278';
  const message = 'Merhaba, Art Garage hakkında bilgi almak istiyorum.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-4 sm:bottom-12 sm:right-6 z-40 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Tooltip */}
      {isHovered && (
        <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-gray-900 text-white text-xs sm:text-sm rounded-lg shadow-lg whitespace-nowrap animate-fadeIn max-w-[200px] sm:max-w-none">
          WhatsApp ile İletişime Geç
          <div className="absolute bottom-0 right-4 sm:right-6 transform translate-y-1/2 rotate-45 w-2 h-2 bg-gray-900"></div>
        </div>
      )}
      
      {/* Button */}
      <div className="relative">
        {/* Pulse animation */}
        <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-75"></div>
        
        {/* Main button */}
        <div className="relative bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white p-3 sm:p-4 rounded-full shadow-2xl transform transition-all duration-300 hover:scale-110">
          <MessageCircle className="h-6 w-6 sm:h-8 sm:w-8" />
        </div>
      </div>

      {/* Badge - Yeni mesaj gibi */}
      <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 sm:h-6 sm:w-6 flex items-center justify-center animate-bounce">
        1
      </div>
    </a>
  );
};

export default WhatsAppFloat;
